<template>
  <div class="container">
    <div class="top">
      <div class="search_total">
        <p class="total">
          共 <span>{{ listTotal }}</span> 条记录
        </p>
      </div>
      <div class="search">
        <el-input placeholder="请输入作者关键词" v-model="keyWords" @keyup.enter.native="toSearch" clearable></el-input>
        <span class="search_img" @click="toSearch"><img src="../../assets/images/search_icon.png" /></span>
      </div>
    </div>
    <!-- 作者列表 -->
    <div class="author-list">
      <ul class="right-list">
        <li v-for="(item, index) in authorList" :key="index">
          <span class="right_index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
          <div class="right-content">
            <div class="title">
              <span @click="toAuthorDetail(item)" v-html="item.authorName"></span>
              <i v-show="item.paperCount != 0" class="addicon"></i>
            </div>
            <div class="num">
              <span><i class="el-icon-s-data"></i>H-index：{{ item.hindex }}</span>
              <span><i class="el-icon-s-comment"></i>论文数：{{ item.worksCount }}</span>
              <span><i class="el-icon-share"></i>引用数：{{ item.citedByCount }}</span>
            </div>
            <p v-if="item.lastKnownInstitutionName">所属机构：<span v-html="item.lastKnownInstitutionName"></span></p>
            <p v-if="item.primayConcepts && item.primayConcepts.length > 0">
              研究领域：<span v-for="(element, idx) in item.primayConcepts" :key="idx"> <span v-html="element"></span><span v-if="idx < item.primayConcepts.length - 1">；</span></span>
            </p>
            <a class="btn" @click="removeCollect(index)">取消关注</a>
            <a v-if="item.subscribe === 0" @click="addSubscribe(index)">订阅</a>
            <a v-if="item.subscribe === 1" @click="removeSubscribe(index)">取消订阅</a>
          </div>
        </li>
      </ul>
      <div class="noData" v-if="total <= 0">
        <img src="../../assets/images/noData.png" />
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "myAuthor",
  data() {
    return {
      keyWords: "",
      listTotal: "",
      authorList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
    };
  },
  components: {},
  mounted() {
    this.getAuthorList();
  },
  methods: {
    toSearch() {
      this.pageNo = 1;
      this.getAuthorList();
    },
    getAuthorList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        type: 3,
      };
      this.$http({
        url: "api/v1/usershare/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.authorList = res.rows;
        this.total = res.total > 10000 ? 10000 : res.total;
        this.listTotal = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getAuthorList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getAuthorList();
    },
    toAuthorDetail(item) {
      if (item.paperCount != 0) {
        this.clickstate(item.shareId);
      }
      let _url = this.$router.resolve({
        path: "/authorDetail",
        query: { authorSid: item.sid },
      });
      window.open(_url.href, "_self");
    },
    //变更状态是否有新增
    clickstate(id) {
      this.$http({
        url: `api//v1/usershare/record/click?shareId=` + id,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
        }
      });
    },
    removeCollect(index) {
      let authorName = this.authorList[index].authorName.split("<span style='color:red'>").join("").split("</span>").join("");
      this.$confirm(`确定要取消对${authorName}的关注吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let postBody = {
          outSid: this.authorList[index].sid,
          type: 3,
        };
        this.$http({
          url: `api/v1/usershare/collect`,
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消关注成功");
            this.getAuthorList();
          }
        });
      });
    },
    //订阅取消订阅
    addSubscribe(index) {
      this.$http({
        url: `api/v1/usershare/deal/subscribe?shareId=${this.authorList[index].shareId}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.pageNo = 1;
          this.$message.success("订阅成功");
          this.getAuthorList();
        }
      });
    },
    removeSubscribe(index) {
      let authorName = this.authorList[index].authorName.split("<span style='color:red'>").join("").split("</span>").join("");
      this.$confirm(`确定要取消对${authorName}的订阅吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: `api/v1/usershare/deal/subscribe?shareId=${this.authorList[index].shareId}`,
          method: "get",
        }).then(res => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消订阅成功");
            this.getAuthorList();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 160px);
  .addicon {
    background: url("../../assets/images/addicon.png") no-repeat;
    position: absolute;
    margin-top: 5px;
    margin-left: 9px;
    width: 24px;
    height: 14px;
  }
  .top {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding: 20px;

    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .search_total {
    display: flex;
    align-items: center;
    .total {
      color: #333;
      span {
        color: #2d8cf0;
      }
    }
    .search {
      margin-left: auto;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      > span {
        background: #2d8cf0;
        height: 40px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .right-list {
    color: #666;
    padding: 0 20px;
    li {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .right_index {
        width: 65px;
      }
      .right-content {
        flex: 1;
        .hover {
          cursor: pointer;
          color: #2d8cf0;
          &:hover {
            color: #2d8cf0 !important;
            text-decoration: underline;
          }
        }
        a {
          border-radius: 4px;
          border: 1px solid #2d8cf0;
          color: #2d8cf0;
          font-size: 16px;
          padding: 5px 15px;
          margin-top: 10px;
          display: inline-block;
          margin-right: 15px;
        }
      }
    }
    .title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      margin-bottom: 10px;
      &:hover {
        background-image: linear-gradient(to right, #006eb3, #2d8cf0);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        label {
          -webkit-text-fill-color: initial;
        }
      }
    }
    .num {
      margin-bottom: 8px;
      span {
        display: inline-block;
        margin-right: 15px;
        label {
          margin-left: 5px;
        }
        i {
          color: #ccc;
          margin-right: 5px;
        }
      }
    }
    p {
      margin-bottom: 8px;
    }
  }
}
</style>
